<template>
  <div class="index" v-loading="loading">
    <div class="rows" v-if="show">
      <div class="row">
        <div class="name">今日总计：</div>
        <div class="value">{{todayMoney}}元</div>
      </div>
      <div class="row">
        <div class="name">昨日总计：</div>
        <div class="value">{{yesterdayMoney}}元</div>
      </div>
      <div class="row">
        <div class="name">本月总计：</div>
        <div class="value">{{monthMoney}}元</div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list0" :key="'0'+index" :class="{done: item.camerasOnlineCount < item.camerasCount}"  @click="routerLink({name: 'aisle',query: {name: item.xqname}})">
        <div class="title">{{item.xqname}}</div>
        <div class="line">
          <div class="name">在线摄像头 </div>
          <div class="value">{{item.camerasOnlineCount}}</div>
        </div>
        <div class="line">
          <div class="name">在用摄像头 </div>
          <div class="value">{{item.camerasCount}}</div>
        </div>
        <div class="line">
          <div class="name">在场车辆数 </div>
          <div class="value">{{item.carOnlineCount}}</div>
        </div>
        <div class="line">
          <div class="name">临时车 </div>
          <div class="value">{{item.carTempCount}}</div>
        </div>
        <div class="line">
          <div class="name">业主车 </div>
          <div class="value">{{item.carUserCount}}</div>
        </div>
        <div class="line">
          <div class="name">贵宾车 </div>
          <div class="value">{{item.carVipCount}}</div>
        </div>
        <div class="line">
          <div class="name">临时业主车 </div>
          <div class="value">{{item.carUserTempCount}}</div>
        </div>
        <div class="line">
          <div class="name">今日收费 </div>
          <div class="value">{{item.payToday}}元</div>
        </div>
        <div class="line">
          <div class="name">昨日收费 </div>
          <div class="value">{{item.payYesterday}}元</div>
        </div>
        <div class="line">
          <div class="name">本月收费 </div>
          <div class="value">{{item.payMonth}}元</div>
        </div>
      </div>
      <div class="item" v-for="(item, index) in list1" :key="'1'+index" :class="{done: item.camerasOnlineCount < item.camerasCount}"  @click="routerLink({name: 'aisle',query: {name: item.xqname}})">
        <div class="title">{{item.xqname}}</div>
        <div class="line">
          <div class="name">在线摄像头 </div>
          <div class="value">{{item.camerasOnlineCount}}</div>
        </div>
        <div class="line">
          <div class="name">在用摄像头 </div>
          <div class="value">{{item.camerasCount}}</div>
        </div>
        <div class="line">
          <div class="name">在场车辆数 </div>
          <div class="value">{{item.carOnlineCount}}</div>
        </div>
        <div class="line">
          <div class="name">临时车 </div>
          <div class="value">{{item.carTempCount}}</div>
        </div>
        <div class="line">
          <div class="name">业主车 </div>
          <div class="value">{{item.carUserCount}}</div>
        </div>
        <div class="line">
          <div class="name">贵宾车 </div>
          <div class="value">{{item.carVipCount}}</div>
        </div>
        <div class="line">
          <div class="name">临时业主车 </div>
          <div class="value">{{item.carUserTempCount}}</div>
        </div>
        <div class="line">
          <div class="name">今日收费 </div>
          <div class="value">{{item.payToday}}元</div>
        </div>
        <div class="line">
          <div class="name">昨日收费 </div>
          <div class="value">{{item.payYesterday}}元</div>
        </div>
        <div class="line">
          <div class="name">本月收费 </div>
          <div class="value">{{item.payMonth}}元</div>
        </div>
      </div>
      <div class="none" v-if="list.length === 0">暂无数据</div>
    </div>
  </div>
</template>
<script>
import { ApiBack } from '../api'
export default {
  data () {
    return {
      list: [],
      list0: [],
      list1: [],
      totalMoney: 0,
      todayMoney: 0,
      yesterdayMoney: 0,
      monthMoney: 0,
      show: false,
      loading: false
    }
  },
  activated () {
    this.index()
    if (this.$store.state.user.data.role === 1) {
      this.show = true
    }
  },
  methods: {
    index () {
      const t = this
      t.$store.dispatch('getUser')
      t.loading = true
      const back = new ApiBack(t.$store.state.user.message)
      back.index().then((res) => {
        if (res.data.code === 0) {
          t.list = res.data.data.indexInfo || []
          t.list0 = t.list.filter((item) => {
            return item.camerasOnlineCount < item.camerasCount
          })
          t.list1 = t.list.filter((item) => {
            return item.camerasOnlineCount >= item.camerasCount
          })
          t.todayMoney = res.data.data.todayMoney
          t.yesterdayMoney = res.data.data.yesterdayMoney
          t.monthMoney = res.data.data.monthMoney
        } else {
          t.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          })
        }
        t.loading = false
      }).catch(() => {
        t.loading = false
      })
    },
    routerLink (obj) {
      this.$router.push(obj)
    }
  }
}
</script>
<style scoped>
.list {
  padding: 1rem;
  display: flex;
  flex-wrap: wrap;
}
.list .item {
  margin: 1rem;
  padding: 1rem;
  width: 22rem;
  min-height: 30rem;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  font-size: 2rem;
}
.list .item.done {
  border-color: #ff0000;
}
.list .item .title {
  font-weight: bold;
  text-align: left;
  padding: 1rem 0;
}
.list .item .line {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list .item .line .value {
  word-break: break-all;
  text-align: right;
}
.none {
  font-size: 2rem;
  text-align: center;
  color: #999999;
  font-weight: 500;
  width: 100%;
}
.rows {
  display: flex;
  align-items: center;
  padding: 1rem;
  padding-bottom: 0;
}
.rows .row {
  display: flex;
  align-items: center;
  margin: 1rem;
  font-size: 2rem;
  margin-bottom: 0;
}
</style>
